export default "__VITE_ASSET__DxVIn4g3__"